export const formatTime = (iso) => {
  const d = new Date(iso);
  return d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString();
};

export const formatDateLastMessage = (iso) => {
  if (!iso) return "";

  const messageDate = new Date(iso);
  const now = new Date();

  const diffMs = now - messageDate;

  if (Number.isNaN(diffMs) || diffMs < 0) {
    return "щойно";
  }

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;

  if (diffMs < minute) {
    return "щойно";
  }

  if (diffMs < hour) {
    return `${Math.floor(diffMs / minute)} хв`;
  }

  if (diffMs < day) {
    return `${Math.floor(diffMs / hour)} год`;
  }

  if (diffMs < month) {
    return `${Math.floor(diffMs / day)} д`;
  }

  if (diffMs < year) {
    return `${Math.floor(diffMs / month)} міс`;
  }

  return `${Math.floor(diffMs / year)} р`;
};

export const formatDateToInt = (str) => {
  if (!str || typeof str !== "string") return 'err: Transform Date To Int';
  const str1 = str.slice(0, 4);
  const str2 = str.slice(5, 7);
  const str3 = str.slice(8, 10);
  return parseInt(str1 + str2 + str3);
}